import * as z from 'zod';

import SingleTeamInfoApiSchema from './SingleTeamInfoApiSchema';

const TeamInfoApiDataSchema = z.object({
  home: SingleTeamInfoApiSchema,
  away: SingleTeamInfoApiSchema,
  lineup_available: z.boolean(),
});

export default TeamInfoApiDataSchema;
